// src/pages/price/marketing-enterprise-v424.tsx
import * as React from "react"
import Seo from "@shared/head/Seo"
import Canonical from "@shared/head/Canonical"
import Breadcrumbs from "@shared/head/Breadcrumbs"
import Layout from "@app/Layout"
import Price from "@features/Price/PriceSales"
import calculator from "@features/Price/calculator.sales.json"
import questions from "@features/Price/faq.sales.json"
import FAQ from "@widgets/FAQ"
import * as style from "@/pages/price/style.module.scss"
import { useInView } from "react-intersection-observer"
import Lottie from "lottie-react"
import lineAnimationQuestion from "@/pages/index/assets/line_5.json"
import markerAnimation from "@/pages/index/assets/animation_7.json"

export const Head = () => (
  <Seo title="Enterprise (маркетинг) | Тарифы по кейсам применения | Carrot quest" description="Маркетинговые возможности Carrot quest уровня Enterprise для сложных воронок и больших аудиторий." path="/price/enterprise-v424/" image="https://www.carrotquest.io/cover/ru/price.jpg" noindex>
  <Breadcrumbs
        list={[
          { name: "Carrot quest", url: "https://www.carrotquest.io/" },
          { name: "Тарифы Carrot quest", url: "https://www.carrotquest.io/price/" },
        ]}
      />
  </Seo>
)

const CarrotPrice = ({ location }) => {
  const inViewOptions = { triggerOnce: true, threshold: 0.2 }
  const { ref: questionsRef, inView: questionsInView } = useInView(inViewOptions)

  return (
    <Layout location={location} className={`${style.pagePrice} page page-price page-price-ru new-design`}>
      <div className="px-0 px-lg-3 mb-5">
        <Price show="enterpriseMarketing" calculator={calculator} />
      </div>
      <section ref={questionsRef} className={`${style.questions} questionsNew`}>
        <h2 className="h1">
          Ответы на{" "}
          <span className={style.highlightDecor}>
            популярные
            {questionsInView && <Lottie animationData={lineAnimationQuestion} loop={false} autoplay={true} />}
          </span>
          <br />
          <span className={style.highlight}>
            вопросы
            {questionsInView && <Lottie animationData={markerAnimation} loop={false} autoplay={true} />}
          </span>
        </h2>
        <FAQ className={style.faqItem} isTitle={true} items={questions} />
      </section>
    </Layout>
  )
}

export default CarrotPrice
